// Create PhysicianOthersEdit.js for the edit mode only
import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { Grid, Paper, Radio, RadioGroup, FormControlLabel } from '@material-ui/core';

const PhysicianOthersEdit = forwardRef(({ otherOptions, onChange }, ref) => {
  const [options, setOptions] = useState({
    status: '' // empty string means no selection
  });

  useEffect(() => {
    if (otherOptions) {
      let status = '';
      if (otherOptions.isRetired) status = 'retired';
      else if (otherOptions.isDeceased) status = 'deceased';
      else if (otherOptions.leftGroup) status = 'leftGroup';

      setOptions({
        status: status
      });
    }
  }, [otherOptions]);

  const handleStatusChange = (event) => {
    const newStatus = event.target.value;
    const updatedOptions = {
      status: newStatus
    };

    setOptions(updatedOptions);

    if (onChange) {
      const changeData = {
        isRetired: newStatus === 'retired',
        isDeceased: newStatus === 'deceased',
        leftGroup: newStatus === 'leftGroup'
      };
      onChange(changeData);
    }
  };

  // In PhysicianOthersEdit component
  useImperativeHandle(ref, () => ({
    getFormData: () => ({
      isRetired: options.status === 'retired',
      isDeceased: options.status === 'deceased',
      leftGroup: options.status === 'leftGroup'
    }),
    validateForm: () => true // Always valid now
  }));

  return (
    <Paper elevation={0} style={{ width: '100%', padding: '0' }}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <RadioGroup
            aria-label="provider-status"
            name="provider-status"
            value={options.status}
            onChange={handleStatusChange}
            style={{ marginTop: '-5px', marginLeft: '20px' }}
          >
            {/* Radio buttons sorted alphabetically */}
            <FormControlLabel
              value=""
              control={<Radio color="primary" size="small" />}
              label="Active"
              style={{ fontSize: '0.9rem', marginBottom: '-5px' }}
              classes={{ label: { fontSize: '0.9rem' } }}
            />
            <FormControlLabel
              value="deceased"
              control={<Radio color="primary" size="small" />}
              label="Deceased"
              style={{ fontSize: '0.9rem', marginBottom: '-5px' }}
              classes={{ label: { fontSize: '0.9rem' } }}
            />
            <FormControlLabel
              value="leftGroup"
              control={<Radio color="primary" size="small" />}
              label="Left Group/Practice"
              style={{ fontSize: '0.9rem', marginBottom: '-5px' }}
              classes={{ label: { fontSize: '0.9rem' } }}
            />
            <FormControlLabel
              value="retired"
              control={<Radio color="primary" size="small" />}
              label="Retired"
              style={{ fontSize: '0.9rem', marginBottom: '-5px' }}
              classes={{ label: { fontSize: '0.9rem' } }}
            />
          </RadioGroup>
        </Grid>
      </Grid>
    </Paper>
  );
});

export default PhysicianOthersEdit;